
import * as sortBy from 'lodash/sortBy'
import { StoreDispatch } from 'interfaces/component'
import { Guards } from 'interfaces/guards'
import AccountsRates, {
  AccountsRatesContainerOwnProps,
  AccountsRatesDispatchProps,
  AccountsRatesOwnProps,
  AccountsRatesStateProps,
} from 'components/features/pfm/AccountsRates/AccountsRates'
import { setFilterCategoryActionCreator } from 'actions/globalActions'
import { connectShadedLoadable, createParallelGuard } from 'helpers/loadableHelpers'
import { peergroupsGuard } from 'guards/globalGuards'
import { accountRatesGuard, memberAllAccountsGuard } from 'guards/accountGuards'
import { CategoryId } from 'interfaces/meta'
import { createForgottenGuardError } from 'helpers/errorHelpers'
import { createSelectedCategoryIdSelector } from 'selectors/globalSelectors'
import { createSelector } from 'reselect'
import { categoryInterestsSelector, linkedRatedAccountsSelector, manualLinkedDetailedAccountsSelector } from 'selectors/accountSelectors'
import { getItemsFromCollection } from 'helpers/normalizeHelpers'
import { opportunityCountersSelector } from 'selectors/oppertunitiesSelectors'
import { OPPORTUNITIES_PAGE } from 'constants/pages'
import { OPPORTUNITIES_PAGE_PLACEMENT } from 'constants/opportunities'
import { State } from 'interfaces/state'

const createMapStateToProps = () => {
  const selectedCategoryIdSelector = createSelectedCategoryIdSelector()

  return createSelector(
    linkedRatedAccountsSelector,
    manualLinkedDetailedAccountsSelector,
    categoryInterestsSelector,
    (state: State, { type }) => selectedCategoryIdSelector(state, type),
    opportunityCountersSelector,
    (linkedRatedAccounts, manualAccounts, categoryInterests, selectedCategoryId, opportunityCounters): AccountsRatesStateProps => {
      if (!linkedRatedAccounts || !categoryInterests) {
        throw createForgottenGuardError('AccountRatesModuleContainer', 'memberAccountDetailsGuard', 'accountRatesGuard')
      }

      manualAccounts = manualAccounts || []

      const allAccounts = [...linkedRatedAccounts, ...manualAccounts]
      const categoryAccounts = allAccounts.filter(
        (account) => account.category.id === selectedCategoryId,
      )

      return {
        categoryInterests: getItemsFromCollection(categoryInterests),
        categoryAccounts: sortBy(categoryAccounts, ({ name }) => name),
        selectedCategoryId,
        opportunityCounters,
      }
    },
  )
}

const mapDispatchToProps = (dispatch: StoreDispatch, { type }: AccountsRatesOwnProps): AccountsRatesDispatchProps => ({
  setActiveTab: (categoryId: CategoryId) => dispatch(setFilterCategoryActionCreator(type, categoryId)),
  onOpportunityLinkClick: (categoryId: CategoryId) =>
    dispatch(setFilterCategoryActionCreator(OPPORTUNITIES_PAGE, categoryId)),
})


const accountsRatesGuards: Guards = [
  peergroupsGuard,
  createParallelGuard(
    memberAllAccountsGuard,
    accountRatesGuard,
  ),
]

const AccountsRatesLoader = connectShadedLoadable<
  AccountsRatesStateProps,
  AccountsRatesDispatchProps,
  AccountsRatesOwnProps & AccountsRatesContainerOwnProps
>(createMapStateToProps, mapDispatchToProps, accountsRatesGuards)(AccountsRates)

const AccountsRatesContainer = (props: AccountsRatesOwnProps) => (
  <AccountsRatesLoader placement={ OPPORTUNITIES_PAGE_PLACEMENT } { ...props } />
)

export default AccountsRatesContainer
